<script setup lang="ts">
import { useRouter } from 'vue-router';
import { computed, onBeforeMount, ref } from 'vue';
import { useEventListener } from '@vueuse/core';
import AppTile from '../molecules/app/AppTile.vue';
import { usePayloadStore } from '../../stores/payload-store';
import { defaultRegisterStateBuilder } from '../../utils/stateBuilder';

const router = useRouter();
const payload = usePayloadStore();

const mode = ref<'register' | 'login'>('register');

const iFrameSrc = computed(() => {
    const state = defaultRegisterStateBuilder(payload.atsUserUuid, payload.encryptedPayload, mode.value);
    return router.resolve({
        name: mode.value,
        query: {
            inline: 1,
            registerState: state,
            state,
        },
    }).href;
});
const iFrameTitle = computed(() => (mode.value === 'register' ? 'Registrieren Formular' : 'Login Formular'));

const iFrameHeight = ref(483); // Standard height for desktop
const iFrameHeightInPx = computed(() => `${iFrameHeight.value}px`);

function receiveMessageFromSSO({ data }) {
    const { type, action, value } = data;
    if (type === 'event' &&
        action === 'updateHeight'
    ) {
        iFrameHeight.value = value;
    } else if (type === 'event' && action === 'switchToLogin') {
        mode.value = 'login';
    } else if (type === 'event' && action === 'switchToRegister') {
        mode.value = 'register';
    }
}

onBeforeMount(() => {
    useEventListener(window, 'message', receiveMessageFromSSO);
});
</script>

<template>
    <AppTile v-track-visibility="{ element: 'Register/Login Step' }">
        <iframe
            class="w-full overflow-y-hidden"
            scrolling="no"
            :title="iFrameTitle"
            :src="iFrameSrc"
            :style="{
                height: iFrameHeightInPx,
            }"
        />
    </AppTile>
</template>
